// useIsPhone — true at the Design Standard's phone breakpoint (≤ 640px), live.
// The same query ui/Modal uses to swap a modal for a sheet; shared here so the
// schedule screens pick list + sheet layouts on the phone without a resize
// listener of their own.
import { useEffect, useState } from "react";

export const PHONE_QUERY = "(max-width: 640px)";

export default function useIsPhone(query = PHONE_QUERY) {
  const get = () => typeof window !== "undefined" && !!window.matchMedia?.(query).matches;
  const [isPhone, setIsPhone] = useState(get);
  useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return undefined;
    const on = () => setIsPhone(mq.matches);
    if (mq.addEventListener) mq.addEventListener("change", on); else mq.addListener(on);
    return () => { if (mq.removeEventListener) mq.removeEventListener("change", on); else mq.removeListener(on); };
  }, [query]);
  return isPhone;
}
